export function getPageInitialSettings() {
  return {
    current: 1,
    limit: 20,
  };
}
export function getPageRecherche() {
  return {
    current: 0,
    limit: 20,
  };
}
